export default {
    general: {
        delete: 'Eliminar',
        edit: 'Editar',
        noDataFound: 'Datos no encontrados',
        treatments: 'Tratamientos',
        patients: 'Pacientes',
        machine: 'Plataforma',
        areas: 'Áreas',
        male: 'Hombre',
        female: 'Mujer',
        other: 'Otros',
        type: 'Tipo',
        yes: 'Sí ',
        no: 'No',
        noDataToDisplay: 'No hay información para mostrar',
        displayingOutOf: 'Mostrando {0} - {0} de {0}',
        expand: 'Expandir',
        collapse: 'Colapso',
        download: 'Descargar',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        pageNotFound: '',
        agree: '',
        on: '',
        off: '',
        autodetected: '',
        notSelected: '',
        roles: {
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
        }
    },

    machineActivity: {
        init: '',
        registered: '',
        pulses: '',
        assign: '',
        updateMachineVersion: '',
        addTreatment: '',
        endGridRound: '',
        error: '',
        ack: '',
        patient: '',
        checkTreatment: ''
    },

    alerts: {
        success: 'Éxito',
        error: 'Error',
        warning: 'Advertencia',
        info: 'Información'
    },

    areas: {
        'Arm': 'Brazo',
        'Axila': 'Axila',
        'Back': 'Espalda',
        'Back of hand': 'Dorso de la mano',
        'Bikini': 'Bikini',
        'Buttok': 'Glúteo',
        'Cheek': 'Mejilla',
        'Chest': 'Pecho',
        'Chin': 'Barbilla',
        'Ear': 'Oreja',
        'Eyebrow': 'Ceja',
        'Finger': 'Dedo',
        'Glabela': 'Glabela',
        'Knee': 'Rodilla',
        'Lower leg': 'Parte inferior de la pierna',
        'Man abdomen': 'Abdomen de hombre',
        'Man face': 'Rostro de hombre',
        'Nape': 'Nuca',
        'Neck': 'Cuello',
        'Nose': 'Nariz',
        'Shoulder': 'Hombro',
        'Thigh': 'Muslo',
        'Toe': 'Dedo del pie',
        'Upper hand': 'Parte superior de la mano',
        'Upper lip': 'Labio superior',
        'Woman abdomen': 'Abdomen de mujer',
        'Woman face': 'Rostro de mujer',
    },

    login: {
        welcome: 'Bienvenidos',
        signIn: 'Iniciar sesión',
        email: 'Correo electrónico',
        password: 'Contraseña',
        forgotPassword: '¿Ha olvidado su contraseña?',
        passwordMustBeChanged: '',
        dontHaveAnAccount: '¿Aún no tiene una cuenta?',
        register: 'Registrarse',
        guide: 'Guía',
        userNamePasswordIncorrect: 'Nombre de usuario o contraseña incorrectos',
    },

    register: {
        title: 'Inducción',
        hasAccount: '¿Ya tienes una cuenta?',
        loginHere: 'Entre aquí',
        buttons: {
            COMPLETE: "Completo",
            CONTINUE: "Continuar",
            PREVIOUS: "Regresa"
        },
        results: {
            SUCCESS: {
                TITLE: '¡Cuenta creada con éxito!',
                DESCRIPTION: {
                    PART_ONE: "Acabamos de enviarle un correo electrónico a",
                    PART_TWO: "Revisa tu correo y sigue las instrucciones para activar tu cuenta."
                },
                CHECK_MOBILE: "Consulta SmartClinic en tu Móvil"
            },
            ERROR: {
                TITLE: '¡Ocurrió un error al crear la cuenta!',
                TRYAGAIN: 'Intentar otra vez'
            }
        },
        errors: {
            UNKNOWN_DISTRIBUTER: 'Distribuidor desconocido. Asegúrese de haber ingresado un código de distribuidor y un país válidos',
            EMAIL_ALREADY_USED: 'La dirección de correo electrónico del usuario ya está en uso. Por favor seleccione un correo electrónico diferente',
            GENERAL_EXCEPTION: 'Ocurrió un error desconocido. Vuelva a intentarlo más tarde o póngase en contacto con nuestro equipo de soporte.',
            MISSING_DISTRIBUTER_COUNTRY: 'Seleccione el país del distribuidor',
            MISSING_DISTRIBUTER_CODE: 'Por favor, introduzca el código de distribuidor',
            MISSING_NAME: 'Se requiere el nombre',
            MISSING_PHONE: 'Se requiere teléfono',
            MISSING_ADDRESS: 'La dirección es necesaria',
            MISSING_ADDRESS_DROPDOWN: 'Seleccione una dirección del menú desplegable',
            MISSING_FULLNAME: 'Se requiere el nombre completo',
            MISSING_EMAIL: 'El correo electrónico del usuario es obligatorio',
            MISSING_PASSWORD: 'se requiere contraseña',
            WRONG_PASSWORD_LENGTH: 'La longitud de la contraseña debe tener al menos 6 caracteres',
            MISSING_AGREE: 'Debe aceptar nuestros Términos y condiciones y nuestra política de privacidad para continuar',
            EMAIL_TAKEN: 'El Email ya existe. Por favor, elija un correo electrónico diferente'
        },
        steps: {
            ACCOUNT_TYPE: {
                MENU: {
                    LABEL: 'Tipo de cuenta',
                    DESCRIPTION: 'Selecciona el tipo de cuenta a crear'
                },
                CONTENT: {
                    TITLE: 'Paso uno: seleccione el tipo de cuenta',
                    DESCRIPTION: 'Para continuar, seleccione uno de los siguientes tipos de cuenta. Cada tipo tiene sus propias características únicas, así que asegúrese de seleccionar el tipo correcto para su organización',
                    CLINIC: {
                        TITLE: 'Clinic',
                        DESCRIPTION: 'Si su organización opera como una sola clínica, elija esta opción'
                    },
                    CHAIN: {
                        TITLE: 'Chain',
                        DESCRIPTION: '¿Está operando una cadena con múltiples clínicas asociadas? Elige esta opción'
                    },
                }
            },
            CONNECT: {
                MENU: {
                    LABEL: 'Conectar',
                    DESCRIPTION: 'Conecte su organización con el distribuidor adecuado'
                },
                CONTENT: {
                    TITLE: 'Paso dos: conecte su',
                    DESCRIPTION: "Para continuar, díganos quién es el distribuidor de productos Alma de su organización. ¡SmartClinic se sincronizará automáticamente con su distribuidor, enviándole alertas importantes y más!",
                    FIELDS: {
                        COUNTRY: {
                            LABEL: "País",
                            DEFAULT_OPTION: "Seleccione el país de la lista.."
                        },
                        CODE: {
                            LABEL: 'Select Distributor',
                            DEFAULT_OPTION: "Select distributor from list.."
                        }
                    }
                }
            },
            ORG_DETAILS: {
                MENU: {
                    DETAILS: 'Detalles',
                    DESCRIPTION: 'Háganos saber más sobre su organización'
                },
                CONTENT: {
                    TITLE: 'Paso tres: detalles sobre su',
                    DESCRIPTION: "Complete las entradas a continuación y proporcione detalles sobre su organización para que SmartClinic le ofrezca la mejor experiencia posible.",
                    FIELDS: {
                        NAME: {
                            LABEL: 'Nombre',
                            PLACEHOLDER: 'Ingrese su nombre..'
                        },
                        PHONE: {
                            LABEL: 'Teléfono',
                            PLACEHOLDER: 'Introduce el teléfono..'
                        },
                        ADDRESS: {
                            LABEL: 'Habla a',
                            PLACEHOLDER: 'Ingresa la direccion..'
                        }
                    }
                }
            },
            USER_DETAILS: {
                MENU: {
                    LABEL: 'Detalles de usuario',
                    DESCRIPTION: 'Cuéntanos más sobre ti para crear una nueva cuenta.'
                },
                CONTENT: {
                    TITLE: "Paso final: detalles del usuario",
                    DESCRIPTION: "Cuéntanos más sobre ti para crear una nueva cuenta. Elija su correo electrónico y contraseña de inicio de sesión, que luego lo ayudarán a acceder a SmartClinic.",
                    FIELDS: {
                        NAME: {
                            LABEL: "Nombre completo",
                            PLACEHOLDER: "Ingrese el nombre completo.."
                        },
                        EMAIL: {
                            LABEL: "Email",
                            PLACEHOLDER: "Introduce tu correo electrónico..'"
                        },
                        PASSWORD: {
                            LABEL: "Contraseña",
                            PLACEHOLDER: "Contraseña..'"
                        },
                        TOS: {
                            AGREE: "he leído y estoy de acuerdo con",
                            TERMS: "Términos y condiciones",
                            PRIVACY: "política de privacidad"
                        }
                    }
                }
            }
        }
    },

    forgotPassword: {
        title: "Forgot Password",
        description: "Enter your SmartClinic email into the following form to reset your password:",
        input: {
            email: {
                label: "Email Address",
                placeholder: "Enter your email.."
            },
            submit: "Submit"
        },
        goback: 'Go back to login',
        success: "Success! Please check your email to procceed with the password reset",
        error: "Error! Could not reset your password. Please try again later."
    },

    resetPassword: {
        title: "Reset Password",
        description: "Choose a new password for your SmartClinic account. Make sure it's secure & easy to remember.",
        input: {
            password: {
                label: "New Password",
                placeholder: "Enter your new password.."
            },
            passwordConfirm: {
                label: "Confirm Password",
                placeholder: "Enter password again.."
            },
            submit: "Reset Password"
        },
        redirect: "Redirecting you in 5 seconds..",
        success: "Success! Your password was succesfully changed.",
        error: "Error! Could not change your password. Please try again later.",
        errorNoMatch: "Password does not match. Make sure you type the same password"
    },

    verifyEmail: {
        title: "",
        description: "",
        cta: "",
        error: {
            title: "",
            description: "",
            cta: ""
        }
    },

    menu: {
        dashboard: 'Tablero',
        patients: 'Pacientes',
        clinics: 'Clínicas',
        clinicsAndChains: 'Cadenas y clínicas',
        staff: 'Personal',
        equipment: 'Equipos',
        platforms: 'Plataformas',
        applicators: 'Aplicadores',
        service: 'Servicio',
        treatments: 'Tratamientos',
        notifications: 'Notificaciones',
        account: 'Mi cuenta',
        helpCenter: 'Centro de ayuda',
        logout: 'Cerrar sesión',
        distributors: 'Distribuidores',
        platformErrors: '',
        serviceCalls: '',
        users: '',
    },

    dashboard: {
        treatmentsGraphInfo: 'Recuento de tratamientos por mes ',
        statistics: 'Estadísticas',
        activePatients: 'Pacientes activas',
        newPatients: 'Nuevas pacientes',
        lastTreatments: 'Últimos tratamientos',
        area: 'Área',
        staff: 'Personal',
        date: 'Fecha',
        goToMachines: 'Ir a la página de plataformas',
        goToApplicators: 'Ir a la página de aplicadores'
    },

    myDetails: {
        accountDetails: 'Detalles de la cuenta ',
        english: 'Inglés',
        spanish: 'Español',
        language: 'Idioma',
        fullName: 'Nombre',
        email: 'Correo electrónico',
        password: 'Contraseña',
        accountDetailsInfo: 'Ver y editar sus datos. El correo electrónico y la contraseña se utilizarán para iniciar sesión en su cuenta. ',
        nameUpdatedSuccessfully: 'Nombre actualizado correctamente ',
        editName: 'Editar nombre',
        currentName: 'Nombre actual',
        newName: 'Nuevo nombre',
        notificationsMail: 'Notificaciones por correo electrónico',
        machineErros: 'Errores de máquina',
        machineErrosInfo: 'Recibir notificaciones cuando ocurran errores en las máquinas',
        changeName: 'Cambiar nombre',
        emailUpdatedSuccessfully: 'Dirección de correo electrónico actualizada correctamente',
        editEmailAddress: 'Editar dirección de correo electrónico',
        currentEmailAddress: 'Correo electrónico actual',
        newEmailAddress: 'Nuevo Email',
        currentPassword: 'Contraseña actual',
        changeEmail: 'Cambiar e-mail',
        passwordUpdatedSuccessfully: 'Contraseña actualizada exitosamente',
        editPassword: 'Editar contraseña',
        newPassword: 'Nueva contraseña',
        confirmNewPassword: 'Confirmar nueva contraseña',
        changePassword: 'Cambiar la contraseña',
        timezone: ''
    },

    account: {
        clinicNameRequired: 'Se requiere el nombre de la clínica',
        maxLength35: 'La longitud máxima es de 35 caracteres',
        clinicEmailRequired: 'Se requiere el correo electrónico de la clínica',
        enterValidEmailAddress: 'Por favor, introduce una dirección de correo electrónico válida',
        enterValidPhoneNumber: 'Por favor ingrese un número de teléfono válido',
        imgMaxSize5mb: 'El tamaño máximo de la imagen es de 5 MB',
        onlyImagesAllowed: 'Solo se permiten imágenes',
        uploadFailed: 'Subida fallida',
        clinicDetails: 'Detalles de la clínica',
        editClinicDetails: 'Edite los detalles de su clínica',
        clinicId: 'ID de la clínica',
        clinicNumber: 'Número de clínica',
        clinicStatus: 'Estado de la clínica',
        clinicName: 'Nombre de la clínica',
        clinicPhoneNumber: 'Número de teléfono de la clínica',
        clinicEmail: 'Correo electrónico de la clínica',

        chainDetails: '',
        editChainDetails: '',
        chainId: 'ID de cadena',
        chainNumber: 'Número de cadena',
        chainStatus: '',
        chainName: 'Nombre de la cadena',
        chainPhoneNumber: '',
        chainEmail: '',
        updateChainData: '',

        address: 'Habla a',
        partOfChain: 'Parte de una cadena',
        independent: 'Independiente (la clínica no pertenece a una cadena)',
        success: 'Éxito',
        country: 'País',
        city: 'Ciudad',
        streetAndNumber: 'Calle y número',
        updateClinicData: 'Actualizar los datos de la clínica',
        approve: 'Aprobar',
        decline: 'Disminución',
        chainRequestApprove: 'La solicitud de la cadena será aprobada y la clínica se agregará a la cadena.',
        chainRequestDecline: 'La solicitud de Chain será rechazada y eliminada.',
        status: 'Estado',
        assignmentRequests: 'Solicitudes de asignación ',
        assignmentRequestsExplain: 'La tabla enumera las solicitudes de asignación recibidas de las cadenas.',
        openingHours: 'Horario de apertura',
        weeklyHours: 'Horas semanales',
        openingHoursTooltipText: 'El horario de apertura de la clínica se está utilizando para calcular el uso promedio de las máquinas.',
        closed: 'Cerrado',
        logoutFromAccount: 'Cerrar sesión en su cuenta',
        logoutLocal: 'Cerrar sesión',
        logoutAll: 'Cierre la sesión de todos sus dispositivos',
        logoutAllText1: '¿Estás seguro de que quieres cerrar sesión en todos tus dispositivos?',
        logoutAllText2: 'Esto incluye su aplicación móvil y cualquier otro navegador que utilice.',
        managedByYourChain: '',

        assignmentRequestsExplainForChain: '',
        addClinic: '',
        assignClinic: '',
        clinicRequestReSend: '',
        clinicRequestDelete: '',
        reSend: '',
        delete: '',
        pending: '',
        approved: '',
        declined: '',
        clinicNumberLocation: '',

        treatmentSettings: {
            treatmentSettings: 'Entornos de tratamiento',
            staffIdAndPatientId: 'Identificación del personal e identificación del paciente',
            staffIdAndPatientIdExplained: 'Según su selección, se requerirá la identificación del paciente y la identificación del personal para realizar un tratamiento',
            staffId: 'Identificación del personal',
            staffIdExplained: 'Según su selección, se requerirá identificación del personal para poder realizar un tratamiento',
            patientId: 'ID del paciente',
            patientIdExplained: 'According to your selection, patient ID will be required in order to perform a treatment',
            noAdditionalData: 'Libre - Sin datos adicionales',
            noAdditionalDataExplained: 'According to your selection, patient ID and staff ID will NOT be required in order to perform a treatment',
            preparationTime: 'Tiempo de preparación',
            preparationTimeExplained: 'El tiempo de preparación se utiliza para calcular el uso promedio de las plataformas y se agrega automáticamente para cada tratamiento realizado.',
            allowedFluenceDeviation: 'Desviación de fluencia permitida',
            allowedFluenceDeviationExplained: 'La desviación de la fluencia se utiliza para medir la precisión del personal.',
            allowedEnergyDeviation: 'Desviación de energía permitida',
            allowedEnergyDeviationExplained: 'La desviación de energía se utiliza para medir la precisión del personal.',
            treatmentSavedDataOptions: 'Opciones de tratamiento de datos guardados',
            treatmentSavedDataOptionsExplained: 'Seleccione si se requieren o no la identificación del paciente y la identificación del personal para realizar un tratamiento. Recomendamos elegir \'ID de personal e ID de paciente\' para disfrutar de todas las funciones de Smart Clinic',
            treatmentProtocols: 'Protocolos de tratamiento',
            viewAndEditTreatmentProtocols: 'Ver y editar protocolos de tratamiento',
            view: 'Vista',
        },
        enabled: 'Habilitado',
        disabled: 'Deshabilitado',
        error: '',
        errors: '',
        changePassword: '',
        currentPassword: '',
        newPassword: '',
        newPasswordAgain: '',
        passwordsNoMatch: '',
        password: '',
        passwordValidation: '',
        name: '',
        email: '',
        created_at: '',
        subRole: '',
        editUser: '',
        deleteUser: '',
        accountUsers: '',
        addAccountUser: '',
        editAccountUser: '',
        save: ''
    },

    notifications: {
        moreNotificationsPending: 'Más notificaciones pendientes',
        noMoreNotifications: 'No mas notificaciones',
        clinic: 'Clínica',
        machine: 'Plataforma',
        machineId: 'ID de plataforma',
        patientId: 'ID del paciente',
        handle: 'Aplicador',
        handleId: 'ID del aplicador',
        skinType: 'Tipo de piel',
        area: 'Área',
    },

    emailPreferences: {
        title: 'Email Preferences',
        subtitle: 'Your current email settings for',
        intro: 'Select which types of emails you’d like to receive from us',
        lists: {
            unfinishedGrid: {
                title: 'Unfinished Grid',
                description: 'Get notified when a treatment is not finished properly.',
            },
            annualService: {
                title: 'Annual Service',
                description: 'We will send you an email when a machine is ready for annual service.',
            },
            newVersion: {
                title: 'New Version',
                description: 'Get notifited when a new machine version is available.',
            },
            scheduledReports: {
                title: 'Scheduled Reports',
                description: 'Get Monthly, Weekly or Quarterly scheduled reports from us.',
            },
            serviceCall: {
                title: 'Service Call',
                description: 'Get notified when a clinic / chain created a new service call.',
            }
        }
    },

    averageSessionsForTreatment: {
        info: 'La cantidad promedio de tratamientos a los que se someterá un paciente en un área específica.',
        header: 'Número de tratamiento promedio por área',
    },

    machinesUsage: {
        header: 'Uso promedio de la máquinas en horas',
        info: 'Uso: tiempo de tratamiento dividido por las horas de trabajo de la clínica',
        usage: 'Uso',
        buyPulses: 'Comprar pulsos',
        overallTreatmentTime: 'Tiempo total de tratamiento',
        PreparationTime: 'Tiempo de preparación',
        unusedTime: 'Tiempo no utilizado',
        pulses: 'Pulsos',
        offline: 'Desconectado',
        online: 'En línea',
    },

    top5Areas: {
        info: 'Top 5 Áreas para cada una de las máquinas y porcentaje de tratamientos.',
        header: 'Las 5 mejores áreas',
    },

    treatmentsAnalytics: {
        info: 'El gráfico muestra los tratamientos agrupados por áreas en diferentes períodos',
        header: 'Análisis de los tratamientos',
    },

    patients: {
        clinicsPatients: 'Pacientes de la clínica',
        patientId: 'ID del paciente',
        patientName: 'Nombre del paciente',
        lastTreatment: 'Ultimo tratamiento',
        area: 'Área',
        stack: '',
        staffName: 'Nombre del personal',
        staffId: 'Identificación del personal',
        gender: 'Género',
        age: 'Edad',
        joinedAt: 'Se unió a las',
        searchPatientByIdOrName: 'Buscar paciente por ID o por nombre',
        addPatient: 'Añadir un paciente',
        updatePatient: 'Actualizar paciente',
        clinicsNewPatient: 'Nuevos pacientes de la clínica',
        viewStaff: 'Ver miembro del personal',
        viewPatient: 'Ver paciente',
        editPatient: 'Edit patient',
        deletePatient: 'Eliminar paciente',
        deletePatientConfirm: 'Está seguro de que desea eliminar a este paciente?',
        deletionIsPermanent: 'La eliminación es permanente y los datos no se pueden restaurar.',
        patientCreatedSuccessfully: 'Paciente creado con éxito',
        patientUpdatedSuccessfully: 'Paciente actualizado con éxito',
        firstName: 'Nombre propio',
        lastName: 'Apellido',
        birthday: 'Cumpleaños',
        skinType: 'Tipo de piel',
        editPatientData: 'Editar los datos del paciente',
        addNewPatient: 'Añadir nuevo paciente',
        dateAndTime: 'Fecha y hora',
        machine: 'Máquina',
        applicator: 'Aplicador',
        staff: 'Personal',
        grid: 'Red',
        pulseCount: 'Pulso #',
        fluence: 'Fluencia [j / cm2]',
        temperature: 'Temperatura [C]',
        energy: 'Energía [kj]',
        lasingTime: 'Tiempo de duración [seg]',
        overallDuration: 'Duración total [min]',
        patientsTreatments: 'Tratamientos del paciente',
        patientDetails: 'Detalles de la paciente',
        generalDetails: 'Detalles generales',
        modes: {
            all: 'Todos',
            current: 'Actual',
            new: 'Nuevo'
        }
    },

    staff: {
        enterPlatformName: '',
        numberOfTreatments: 'Numero de tratamientos',
        lasingTime: 'Tiempo duradero',
        goToStaffPage: 'Ir a la página del personal',
        deleteStaff: 'Eliminar personal',
        staffId: 'Identificación del personal',
        staffName: 'Nombre del personal',
        lastTreatment: 'Ultimo tratamiento',
        joinedAt: 'Se unió a las',
        treatments: 'Tratamientos',
        addStaffMember: 'Agregar un miembro del personal',
        searchStaffById: 'Buscar miembro del personal por ID',
        clinicStaff: 'Personal de la clínica',
        chainsStaff: 'Personal de la chain',
        selectTimePeriod: 'Seleccionar período de tiempo',
        selectYAxis: 'Seleccione Y-Axis',
        filterByStaff: 'Filtrar por personal',
        showingAllStaffMembers: 'Mostrando todos los miembros del personal',
        filterByAreas: 'Filtrar por áreas',
        showingAllAreas: 'Mostrando todas las áreas',
        search: 'Buscar',
        staffPerformanceAnalysisGraph: 'Gráfico de análisis del desempeño del personal',
        confirmDelete: '¿Está seguro de que desea eliminar a este miembro del personal?',
        deletionIsPermanent: 'La eliminación es permanente y los datos no se pueden restaurar.',
        delete: 'Borrar',
        allAreas: 'Todas las areas',
        generalDetails: 'Detalles generales',
        deleteStaffMember: 'Eliminar miembro del personal',
        editStaffDetails: 'Editar los detalles del personal',
        searchTreatmentsByPatientId: 'Buscar tratamientos por ID de paciente',
        dateAndTime: 'Fecha y hora',
        machine: 'Plataforma',
        applicator: 'Aplicador',
        patientId: 'ID del paciente',
        area: 'Área',
        stack: '',
        grid: 'Red',
        pulseCount: 'Pulso #',
        fluence: 'Fluencia [j / cm2]',
        temperature: 'Temperatura [C]',
        energy: 'Energía [kj]',
        lasingTimeSec: 'Tiempo de duración [seg]',
        overallDuration: 'Duración total [min]',
        staffsTreatments: 'Tratamientos del personal',
        statistics: 'Estadísticas',
        treatment: 'Tratamiento',
        preparation: 'Preparación',
        hours: 'Horas',
        patients: 'Pacientes',
        fluenceAccuracy: 'Precisión de fluencia',
        energyAccuracy: 'Precisión energética',
        treatmentsPerPatient: 'Tratamientos por paciente',
        patientsExplained: 'El número de pacientes tratados por un miembro del personal.',
        fluenceAccuracyExplained: 'Precisión de fluencia según los valores recomendados por el tratamiento',
        energyAccuracyExplained: 'Precisión energética según los valores recomendados por el tratamiento',
        treatmentsPerPatientExplained: 'El número medio de tratamientos por paciente, realizado por un miembro del personal.',
        treatmentsExplained: 'Cantidad total de tratamientos realizados por un miembro del personal',
        updateStaffMember: 'Actualizar miembro del personal',
        name: 'Nombre',
        personalId: 'Identificación Personal',
        editStaffMember: 'Editar miembro del personal',
        staffCreatedSuccessfully: 'Miembro del personal agregado correctamente',
        staffUpdatedSuccessfully: 'Miembro del personal actualizado con éxito',
        allErrorTypes: '',
        addStaff: '',
        allClinics: '',
        clinic: '',
        created_at: '',
        email: '',
        goToStaff: '',
        last_treatment: '',
        personal_id: '',
        searchForStaffMember: '',
        selectClinic: '',
        staffMembers: '',
        cannotChangeStaffClinic: '',
        staffMember: '',
        staffTreatments: '',
        noDataFound: ''
    },

    service: {
        errorsGraph: '',
        service: 'Servicio',
        myEquipment: 'Mi equipo',
        clickForMoreData: 'Haga clic en cualquiera de los siguientes para ver más datos',
        noEquipment: 'No se encontró ningún equipo registrado en su clínica',
        errorStatistics: 'Estadísticas de error',
        contactUsTxt: 'Contacta con nosotros',
        haveGeneralQuestion: '¿Tiene una pregunta general sobre nuestro sitio web?',
        haveProblem: '¿Tiene algún problema con una de sus máquinas?',
        openServiceCall: 'Abrir una llamada de servicio',
        totalErrors: 'Errores totales',
        almaProductFamily: 'Familia de productos Alma',
        activeServiceCalls: {
            deleteServiceCall: 'Eliminar llamada de servicio',
            createdAt: 'Creado en',
            errorCode: 'Código de error',
            errorName: 'Nombre de error',
            machineId: 'ID de plataforma',
            machineName: 'Nombre de la plataforma',
            applicatorId: 'ID del aplicador',
            applicatorName: 'Nombre del aplicador',
            activeServiceCalls: 'Llamadas de servicio activas',
            allErrors: 'Todos los errores',
        },
        contactUs: {
            machinesConnectionAndManagement: 'Conexión y gestión de máquinas',
            staffManagement: 'Gestión de personal',
            patientsManagement: 'Manejo de pacientes',
            other: 'Otro',
            errorSubmittingForm: 'Error al enviar el formulario',
            successSubmittingForm: 'Tu llamada ha sido recibida.',
            contactUs: 'Contacta con nosotros',
            name: 'Nombre',
            enterYourName: 'Introduzca su nombre',
            email: 'Correo electrónico',
            enterEmail: 'Ingrese su dirección de correo electrónico',
            country: 'País',
            title: 'Título',
            machine: 'Plataforma',
            explainProblem: 'Explica tu problema',
            submit: 'Enviar',
            content: 'Contenido'
        },
        serviceCall: {
            serviceCallReceived: 'Tu llamada ha sido recibida.',
            emailSent: 'Le enviamos un correo electrónico con los detalles de su llamada.',
            someFieldsContainErrors: 'Algunos de los campos contienen errores. Corríjalos y vuelva a intentarlo.',
            openServiceCall: 'Abrir una llamada de servicio',
            name: 'Nombre',
            enterYourName: 'Introduzca su nombre',
            phoneNumber: 'Número de teléfono',
            enterPhoneNumber: 'Ingrese su número telefónico',
            email: 'Dirección de correo electrónico',
            enterEmail: 'Ingrese su dirección de correo electrónico',
            country: 'País',
            selectCountry: 'Seleccione un país',
            city: 'Ciudad',
            selectCity: 'Ingrese ciudad',
            zipCode: 'Código postal',
            enterZipCode: 'Código postal',
            address: 'Habla a',
            enterAddress: 'Calle y número',
            distributorId: 'ID de distribuidor',
            isSystemDown: '¿Tu sistema está caído?',
            reportNumber: 'Numero de reporte',
            callTime: 'La llamada se grabará en',
            machine: 'Platforma',
            selectMachine: 'Seleccione una plataforma',
            machinesName: 'Nombre de la plataforma',
            machineId: 'ID de la plataforma',
            machineType: 'Tipo de plataforma',
            ip: 'Dirección IP',
            softwareVersion: 'Versión del software',
            applicator: 'Aplicador',
            selectApplicator: 'Seleccione un aplicador',
            applicatorId: 'ID del aplicador',
            specifications: 'Especificaciones',
            content: 'Contenido',
            explainProblem: 'Explica tu problema',
            submit: 'Enviar',
        },
        contactDistributor: {
            contactDistributor: 'Distribuidor de contacto',
            productName: 'Nombre del producto',
            selectProduct: 'escoja un producto',
            contentPlaceHolder: 'Describe tu solicitud',
            contentInitialText: 'Hola, \n\nMe estoy comunicando con usted sobre el producto seleccionado. \n\nComuníquese conmigo cuando esté disponible. \n\nGracias.'
        },

        faq: 'Preguntas más frecuentes',
        learnMore: 'Más información >',

        ServiceCalls: '',
        chainPlatformErrors: '',
        chainPlatformErrorsGraph: '',
        clinicPlatformErrors: '',
        clinicPlatformErrorsGraph: '',
        allClinics: '',
        dateAndTime: '',
        clinic: '',
        systemStatus: '',
        platform: '',
        applicator: '',
        serviceNumber: '',
        text: '',
        byClinic: '',
        search: '',
        searchForServiceCall: '',
        systemDown: '',
        allErrorTypes: '',
        code: '',
        title: '',
        byError: '',
        searchForError: '',
        notPlatformRelated: '',
        down: '',
        showMessage: '',
        deleteServiceCall: '',
        delete: '',
        operational: '',
        notApplicatorRelated: '',
        notClinicRelated: '',
        platformErrors: '',
        platformErrorsGraph: '',
        status: '',
        byStatus: '',
        all: '',
        open: '',
        closed: '',
    },

    parameters: {
        areaSettingsForApplicators: 'Configuraciones de área para aplicadores',
        shr: '',
        shrStack: '',
        skinType: 'Tipo de piel',
        hairDensity: 'Densidad del cabello',
        fluence: 'Fluencia',
        stackMode: '',
        numberOfPasses: 'Número de pases',
        energy: 'Energía',
        totalEnergyWithRange: 'Energía total {0} la cuadrícula (kJ)',
        areaSize: 'Tamaño del área',
        defaultWorkState: 'Estado de trabajo predeterminado',
        sparse: 'Escaso',
        coarse: 'Grueso',
    },

    helpCenter: {
        videoGuides: 'Guías de video',
        searchForVideo: 'Buscar un video',
    },

    machines: {
        clinicPlatforms: 'Máquinas de la clínica',
        machinesStatistics: 'Estadísticas de máquinas',
        machines: 'Máquinas',
        machineActivityStatus: '',
        sortBy: 'Ordenar por',
        searchMachine: 'Busca una maquina',
        nameOrId: 'Nombre o cédula',
        machineId: 'ID de la máquina',
        machineName: 'Nombre de la máquina',
        dateAdded: 'Fecha añadida a la clínica',
        platformDetails: 'Platform details',
        platformUsage: 'Platform\'s usage',
        platformTreatments: 'Tratamientos de plataforma',
        area: 'Áreas',
        stack: '',
        staff: 'Miembro del equipo',
        month: 'fechas',
        serialNumber: 'Número de serie',
        applicator: 'Aplicador',
        daily: 'A diario',
        monthly: 'Mensual',
        numberOfTreatments: 'Numero de tratamientos',
        selectTimePeriod: 'Seleccionar fechas',
        period: 'Período',
        applicatorsRegisteredToPlatform: 'Aplicadores registrados en la plataforma',
        dateAndTime: 'Fecha y hora',
        errorCode: 'Código de error',
        errorName: 'Nombre de error',
        applicatorId: 'ID del aplicador',
        platformErrors: 'Errores de plataforma',
        platformApplicators: 'Aplicadores de plataforma',
        noApplicatorsToDisplay: 'Sin aplicadores para mostrar',
        updateRequired: 'Se requiere actualización de firmware',
        upToDate: 'Firmware actualizado',
        update: 'Actualice el firmware',
        contactSupport: 'Soporte de contacto',
        fluenceAccuracyExplained: 'Exactitud de la fluencia según los valores recomendados por el tratamiento',
        energyAccuracyExplained: 'Precisión energética según los valores recomendados por el tratamiento',
        usageExplained: 'El uso de la plataforma considera el horario de apertura de la clínica',
        usage: 'Uso',
        energyAccuracy: 'Precisión energética',
        fluenceAccuracy: 'Precisión de fluencia',
        platformUpdateHeader: 'Actualización del firmware de la plataforma',
        platformUpdateExplain: 'Para actualizar el firmware de la plataforma a la última versión, escanee el código QR',
        platformUpdateRequested1: 'Ha solicitado una actualización de firmware para su plataforma.',
        platformUpdateRequested2: 'Su distribuidor se comunicará con usted a la brevedad.',
        platformUpdateHavingTrouble: '¿Tiene problemas para actualizar?',
        platformUpdateClickHere: 'haga clic aquí',
        platformUpdateClickHereCont: 'para ponerse en contacto con el distribuidor para obtener la última actualización de firmware.',
        grid: '',
        pulseCount: 'Pulso #',
        fluence: 'Fluencia [j / cm2]',
        temperature: 'Temperatura [C]',
        energy: 'Energía [kj]',
        lasingTime: 'Tiempo de duración [seg]',
        overallDuration: 'Duración total [min]',
        areaName: 'Nombre del área',
        patient: 'ID del paciente',
        platform: 'Plataforma',
        platforms: 'Plataformas',
        platformName: 'Nombre de la plataforma',
        enterPlatformName: 'Ingrese un nombre para la plataforma',
        updateName: 'Actualizar nombre',
        treatments: 'Tratos',
        id: 'ID',
        newPlatformAdded: 'Nueva plataforma agregada',
        namePlatform: 'Seleccione un nombre y agréguelo a su clínica.',
        model: 'Modelo',
        name: 'Nombre',
        addToClinic: 'Agregar a la clínica',
        clinicPlatformsStatistics: `Estadísticas de las plataformas de la clínica`,
        chainPlatformsStatistics: 'Estadísticas de las plataformas de la cadena',
        chainPlatforms: 'Plataformas de la cadena',
        byClinic: 'Por clínica',
        searchPlatform: 'Plataforma de búsqueda',
        platformID: 'ID de plataforma',
        platformNameOrId: 'Nombre o ID de la plataforma',
        timePeriod: 'Periodo de tiempo',
        timePeriodExplained: 'El período de tiempo seleccionado solo afecta al gráfico circular de uso. Todas sus plataformas siempre se presentan.',
        lastConnected: '',
        goToPlatformPage: '',
        goToClinicPage: '',
        platformId: '',
        firmware: '',
        pieChart: {
            lasingEnglish: 'Lasing time / Treatment time',
            online: 'Tiempo en línea / Horario de apertura de la clínica', 
            treatment: 'Tiempo de tratamiento + Preparación / Tiempo en línea',
            lasing: 'Tiempo de duración / Tiempo de tratamiento + Preparación',
            noActivity: 'No hay actividad',
        },
        transferPlatformToClinic: 'Transferir plataforma a la clínica',
        transferPlatformToClinicOrDetach: '',
        platformDetached: '',
        save: '',
        unlimited: '',
        limited: '',
        remainingPulses: '',
        detached: '',
        detach: '',
        platformWillBeDetachedWarning: '',
        status: '',
        detachedPlatforms: '',
        platformsAttachedToClinics: '',
        connectedToClinic: '',
        clinicName: '',
        versionInfo: '',
        lastConnection: '',

        versions: {
            addVersion: '',
            addedAt: '',
            addedBy: '',
            countryGroup: '',
            currentVersions: '',
            manageVersions: '',
            module: '',
            version: '',
            versionsHistoryTable: '',
            versionsHistoryTableExplained: '',
            beCareful: '',
            newVersion: '',
            platform: '',
            platformType: '',
            versionNameOrNumber: ''
        },
        modes: {
            all : '',
            attached: '',
            detached: '',
            online: '',
            offline: ''
        },
        allClinics: '',
        attachedDetached: '',
        onlineStatus: '',
        clinics: ''
    },

    applicators: {
        clinicApplicators: 'Aplicadores de la clínica',
        chainApplicators: 'Aplicadores de cadena',
        sortBy: 'Ordenar por',
        applicatorId: 'ID del aplicador',
        applicatorModelName: 'Nombre del modelo',
        dateAdded: 'Fecha añadida a la clínica',
        searchApplicator: 'Busque un aplicador',
        confirmApplicatorDeletion: 'Confirmar la eliminación del aplicador',
        deletionIsPermanent: 'La eliminación es permanente y los datos no se pueden restaurar',
        deleteApplicator: 'Retire el aplicador de la clínica',
        editApplicatorSN: 'Editar el número de serie del aplicador',
        addApplicatorSN: 'Agregar el número de serie del aplicador',
        pulses: 'Pulsos',
        noSpecificationsYet: 'Aún no tenemos las especificaciones para este producto',
        handleSN: 'Número de serie del aplicador',
        handleSnExplained: 'El número de serie de su aplicador (o SN) se puede encontrar en la etiqueta adjunta.',
        enterHandleSN: 'Ingrese el número de serie del aplicador',
        updateSN: 'Actualizar',
        allClinics: '',
        applicators: '',
        clinics: ''
    },

    treatments: {
        TreatmentTypesAndProtocols: 'Tipos de tratamientos y protocolos',
        explain1: 'El sistema Soprano es una plataforma de eliminación de vello basada en diodos que puede tratar prácticamente cualquier área del cuerpo y es apta para todo tipo de vello y piel.',
        explain2: 'El protocolo de tratamiento puede variar entre las distintas partes del cuerpo en función del tipo de piel, el color de vello, la densidad y el tamaño del área tratada.',
        explain3: 'La plataforma permite el uso de diversos modos de tratamiento: supereliminación de vello (Super Hair Removal o SHR), modo SHR Stack (ráfagas de pulsos) y HR (modo de pulso único).',
        explain4: 'El modo SHR es más adecuado para áreas grandes independientemente del tipo de piel o la densidad del vello y está diseñado para que, en un área cuadriculada dada, sea necesario aplicar la energía acumulativa recomendada para que sea eficaz y seguro.',
        explain5: 'Trabajar en el modo SHR es una técnica dinámica ("en movimiento"), que requiere hasta 10 Hz y una corriente de hasta 20 J/cm2.SHR es adecuado para áreas tan grandes como cuadrículas de 900 cm2 y tan pequeñas como 150cm2 según el aplicador utilizado. Los modos SHR Stack y HR se utilizan para las áreas más pequeñas (> 150cm2), pero son tan eficaces como el modo SHR.',

        treatmentsCount: 'Tratamientos por Área',
        treatmentsCountInfo: 'Número de tratamientos realizados para cada una de las áreas de su clínica',
        clinicTreatments: 'Tratamientos de la clínica',
        recommendedTreatmentParameters: 'Parámetros de tratamiento recomendados',
        skinType: 'Tipo de piel',
        hairDensity: 'Densidad del cabello',
        handleType: 'Encargarse de',
        area: 'Área',
        pretreatmentProtocols: 'Protocolos de tratamientos',
        pretreatmentProtocolsInfo: 'Obtenga el protocolo de tratamiento recomendado seleccionando los parámetros de tratamiento',
        sparse: 'Escaso',
        coarse: 'Grueso',
        staffId: 'Identificación del personal',
        nameOrId: 'Nombre o cédula',
        patientId: 'Patient ID',

        chainTreatments: '',
        patientTreatments: '',
        staffsTreatments: '',
        clinic: '',
        staff: '',
        patient: '',
        platform: '',
        applicator: '',
        areaName: '',
        stack: '',
        mode: '',
        pulseCount: '',
        fluence: '',
        temperature: '',
        energy: '',
        overallDuration: '',
        search: '',
        searchForChain: '',
        searchForClinic: '',
        byClinic: '',
        allClinics: '',
        byArea: '',
        allAreas: '',
        savedData: '',
        dateAndTime: '',
        platformTreatments: '',
        byErrorType: '',
        addTreatment: '',
        errorsFound: '',
        time: '',
        treatmentMode: '',
        frequency: '',
        gridSize: '',
        lasing_time: '',
        treatmentGrids: '',
        platformNotAssociated: '',
    },

    dateTime: {
        selectDate: 'Seleccione fecha',
        Q: 'T',
        dateAndTime: 'Seleccionar período de tiempo',
        sunday: 'Domingo',
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        hours: 'Horas',
        minutes: 'Minutos',
        days: 'Días',
    },

    chainDashboard: {
        myClinics: 'Mis Clínicas',
        myClinicsInfo: 'Visualización de todas las clínicas registradas en su cadena en un mapa',
        clinicName: 'Nombre de la clínica',
        clinicNumber: 'Número de clínica',
        platforms: 'Plataformas',
        patients: 'Pacientes ',
        staffMembers: 'Los miembros del personal',
        noLocationFound: 'No se encontró ninguna ubicación',
        topStaffMembers: 'Principales miembros del personal',
        topStaffMembersInfo: 'Visualización de los mejores miembros del personal en su cadena en el rango de fechas seleccionado',
        topStaffMembersNotFound: 'No se encontraron miembros del personal con tratamientos en el período de tiempo seleccionado.',
        topStaffMembersToSeeResults: 'Para ver los resultados, debe ingresar la identificación del personal al comenzar un tratamiento.',
        name: 'Nombre',
        treatments: 'Tratos',
        noTreatmentsInPeriod: 'No hay tratamientos en esta clínica en el período de tiempo seleccionado',
        lastTreatment: 'Ultimo tratamiento',
        mostUsedApplicators: 'Aplicadores más usados',
        noApplicatorsUsed: '',
        mostUsedApplicatorsInfo: 'Listado de aplicadores que se utilizaron en los últimos 30 días únicamente',
        pulseNumberVeryHigh: 'El número de pulsos es muy alto',
        applicatorWarrantySoonVoid: 'La garantía del aplicador pronto se anulará',
        applicatorWarrantyVoided: 'Garantía del aplicador anulada',
        orderBy: 'Ordenar por',
        added: 'Agregado',
        pulseNumber: 'Recuento de pulsos',
        topTreatmentsPerClinic: 'Tratamientos más populares',
        topTreatmentsPerClinicInfo: 'Visualización de las áreas de tratamiento más populares para cada una de sus clínicas, en un período de tiempo específico',
        lastErrors: 'Últimos errores',
        lastErrorsInfo: 'Visualización de los últimos errores reportados por plataformas en su cadena',
        clinic: 'Clínica',
        platform: 'Plataforma',
        error: 'Error',
        time: 'Tiempo',
        offlinePlatforms: 'Plataformas sin conexión',
        offlinePlatformsInfo: 'Lista de plataformas que no estuvieron conectadas durante dos días o más',
        lastConnected: 'Última conexión',
        platformUsageStatistics: 'Estadísticas de uso de plataformas',
        platformUsageStatisticsInfo: 'Mostrando estadísticas de uso de las plataformas registradas en sus clínicas, en un rango de fechas seleccionado',
        used: 'Usó',
        unused: 'No usado',
        preparation: 'Preparación',
        clinics: 'Clínicas',
        chainPatients: 'Chain Patients',
        newChainPatients: 'New Chain Patients'
    },
    clinics: {
        avgUsage: 'Uso promedio',
        viewClinic: 'Ver Clínica',
        deleteClinic: '',
        deletionIsPermanent: '',
        chainClinics: '',
        searchClinic: '',
        searchByNameNumberOrId: '',
        clinicId: '',
        clinicName: '',
        clinicChainName: '',
        clinicChainNumber: '',
        clinicNumber: '',
        platforms: '',
        applicators: '',
        patients: '',
        staff: '',
        creationDate: '',
        phoneNumber: '',
        address: '',
        workingMode: '',
        clinic: '',
        chain: '',
        type: '',
        clinicsAndChains: '',
        viewReport: '',
        deleteReport: '',
        downloadReport: '',
        pending: '',
        processing: '',
        completed: '',
        failed: '',
        unknown: '',
        restoreClinic: '',
        restoreThisClinic: '',
        restore: '',
        deleteSuccessMessage: '',
        restoreSuccessMessage: '',
        modes: {
            all : '',
            active: '',
            deleted: ''
        }
    },
    distributors : {
        code: `Código de Distribuidor`,
        name: 'Nombre de Distribuidor',
        country: 'País',
        totalClinics: 'Clínicas y Cadenas Asignadas',
        totalPlatforms: 'Plataformas Pareadas',
        totalApplicators: 'Aplicadores Pareados',
        searchDistributor: 'Buscar Distribuidor',
        searchByNameCodeOrCountry: 'Buscar por nombre, código o país',
        numberOfClinics: '# de Clínicas',
        min: 'Min',
        max: 'Max',
    },
    videos: {
        changeMachineTreatmentMode: '',
        staffPerformanceAnalysis: '',
        smartClinicCrashCourse: '',
        notificationsAndAlerts: '',
        editPatientDetails: '',
        addNewStaffMembers: '',
        editAccountDetails: '',
        connectADevice: ''
    },

    workingModes: {
        1: '',
        2: '',
        3: '',
        4: '',
    },

    termsAndConditions: {
        header: 'Alma Lasers: Términos de servicio de Smart Clinic',
    },

    gettingStarted: {
        title: '',
        description: "",
        help: {
            title: '',
            description: {
                partOne: '',
                partTwo: '',
                link: ''
            }
        },
        showAgain: "",
        confirm: '',
        cards: {
            connectYourPlatform: {
                title: '',
                description: '',
                cta: ''
            },
            setWorkingHours: {
                title: '',
                description: '',
                cta: ''
            },
            addStaffMember: {
                title: '',
                description: '',
                cta: ''
            },
            connectMyFirstClinic: {
                title: '',
                description: '',
                cta: ''
            },
            manageMyClinics: {
                title: '',
                description: '',
                cta: ''
            },
            manageMyClinicsAndChains: {
                title: '',
                description: '',
                cta: ''
            },
            manageServiceCalls: {
                title: '',
                description: '',
                cta: ''
            }
        }
    },

    tours: {
        AddStaffMember: [
            {
                title: '',
                content: '',
            },
            {
                title: '',
                content: '',
                confirm: ''
            }
        ],
        ConnectYourFirstPlatform: [
            {
                title: '',
                content: '',
                confirm: ''
            },
            {
                title: '',
                content: ``,
                confirm: ''
            }
        ],
        ConnectYourFirstClinic: [
            {
                title: '',
                content: '',
            },
            {
                title: '',
                content: '',
                confirm: ''
            }
        ],
        ManageMyClinics: [
            {
                title: '',
                content: '',
            },
            {
                title: '',
                content: '',
            },
            {
                title: '',
                content: '',
                confirm: ''
            }
        ],
        ManageServiceCalls: [
            {
                title: '',
                content: ''
            },
            {
                title: '',
                content: ''
            },
            {
                title: '',
                content: '',
                confirm: ''
            }
        ],
        SetMyWorkingHours: [
            {
                title: '',
                content: ''
            },
            {
                title: '',
                content: '',
                confirm: ''
            }
        ]
    },
    users: {
        accountUsers: '',
        name: '',
        email: '',
        created_at: '',
        admin: '',
        all: '',
        chain: '',
        clinic: '',
        distributor: '',
        goTo: '',
        master: '',
        search: '',
        staff: '',
        subRole: '',
        type: '',
        viewer: '',
        searchByUser: '',
        personalId: '',
        allUsers: ''
    }
};
